module.exports = __webpack_public_path__ + "img/florian_detourne_2.2939c4dd.jpg";